import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface AssessmentState {
  notes?: string;
  assessment: Record<string, string>;
  diagnoses?: string[];
  symptoms: string[];
}

const initialState: AssessmentState = {
  assessment: {},
  diagnoses: [],
  symptoms: [],
};

interface SetAssessmentParams {
  notes?: string;
  assessment: Record<string, string>;
  diagnoses?: string[];
  symptoms?: string[];
}

const assessmentSlice = createSlice({
  name: "Assessment",
  initialState,
  reducers: {
    setAssessment: (state, action: PayloadAction<SetAssessmentParams>) => {
      console.log(
        `Set assessment is called payload ${JSON.stringify(action.payload)}`
      );
      state.notes = action.payload.notes;
      state.assessment = action.payload.assessment;
      state.diagnoses = action.payload.diagnoses || [];
      state.symptoms = action.payload.symptoms || [];
    },
  },
});

export default assessmentSlice.reducer;
export const { setAssessment } = assessmentSlice.actions;
